/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetNoteQueryResult } from '../../models/get-note-query-result';

export interface ApiPlanGetNoteGet$Params {
  Id?: string;
}

export function apiPlanGetNoteGet(http: HttpClient, rootUrl: string, params?: ApiPlanGetNoteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetNoteQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiPlanGetNoteGet.PATH, 'get');
  if (params) {
    rb.query('Id', params.Id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetNoteQueryResult>;
    })
  );
}

apiPlanGetNoteGet.PATH = '/api/Plan/GetNote';
